import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, eur, eur0 } from './pilotageApi';

function Row({ r, children, onOpen }) {
  return (
    <div className="rw" data-testid={`row-${r.id}`}>
      <div className="gw" style={{ cursor: 'pointer' }} onClick={() => onOpen(r.id)} data-testid={`open-row-${r.id}`}>
        <div className="t">{r.client_nom || 'Client'} <span className="mono" style={{ color: 'var(--t3)', fontWeight: 500 }}>· {r.numero}</span></div>
        <div className="m">
          {r.date_livraison ? `Événement ${r.date_livraison}` : 'Date à définir'}
          {r.nb_articles ? ` · ${r.nb_articles} article${r.nb_articles > 1 ? 's' : ''}` : ''}
          {r.adresse_livraison ? ` · ${r.adresse_livraison}` : ''}
        </div>
      </div>
      <div className="am">{eur(r.total)}</div>
      <div className="ac">{children}</div>
    </div>
  );
}

function Empty({ t }) { return <div className="empty">{t}</div>; }

export default function Aujourdhui() {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const [flash, setFlash] = useState(null);

  const load = useCallback(() => {
    api.aujourdhui().then(setData).catch((e) => setErr(e.message));
  }, []);
  useEffect(() => { load(); }, [load]);

  const open = (id) => nav(`/pilotage/dossier/${id}`);

  async function act(fn, msg) {
    try { await fn(); setFlash(msg); load(); setTimeout(() => setFlash(null), 2500); }
    catch (e) { setFlash(`⚠️ ${e.detail || e.message}`); setTimeout(() => setFlash(null), 3500); }
  }

  if (err) return <div className="wrap"><div className="nt ba">{err}</div></div>;
  if (!data) return <div className="load" data-testid="aujourdhui-loading">Chargement…</div>;

  const c = data.compteurs;
  const b = data.blocs;

  return (
    <>
      <div className="top">
        <h1>Aujourd'hui</h1>
        <span className="ctx mono">{data.date}</span>
        <div className="sp" />
        <button className="btn btn-p" data-testid="btn-nouveau-dossier" onClick={() => nav('/admin/devis')}>+ Nouveau dossier</button>
      </div>
      <div className="wrap">
        {flash && <div className="nt ok" data-testid="flash">{flash}</div>}

        <div className="cts" data-testid="compteurs">
          <button className={`ct ${c.demandes ? 'al' : ''}`} data-testid="ct-demandes" onClick={() => {}}><div className="v mono">{c.demandes}</div><div className="l">demandes</div></button>
          <button className="ct" data-testid="ct-devis"><div className="v mono">{c.devis_sans_reponse}</div><div className="l">devis sans réponse</div></button>
          <button className="ct" data-testid="ct-preparer"><div className="v mono">{c.a_preparer}</div><div className="l">à préparer</div></button>
          <button className="ct" data-testid="ct-livrer"><div className="v mono">{c.a_livrer}</div><div className="l">à livrer</div></button>
          <button className="ct" data-testid="ct-recuperer"><div className="v mono">{c.a_recuperer}</div><div className="l">à récupérer</div></button>
          <button className={`ct ${c.impayes ? 'al' : ''}`} data-testid="ct-impayes"><div className="v mono">{c.impayes}</div><div className="l">impayés</div></button>
          <button className="ct mo" data-testid="ct-montant"><div className="v mono">{eur0(c.montant_en_attente)}</div><div className="l">en attente</div></button>
        </div>

        {/* 1. Nouvelles demandes */}
        <div className="bk" data-testid="bloc-demandes">
          <div className="bh"><h2>Nouvelles demandes</h2><span className="n">{b.demandes.length}</span></div>
          {b.demandes.length === 0 ? <Empty t="Aucune nouvelle demande." /> : b.demandes.map((r) => (
            <Row key={r.id} r={r} onOpen={open}>
              <button className="btn btn-s btn-g" data-testid={`acc-${r.id}`} onClick={() => act(() => api.transition(r.id, 'envoyer'), 'Devis envoyé au client.')}>Accepter et faire le devis</button>
              <button className="btn btn-s btn-r" data-testid={`ref-${r.id}`} onClick={() => act(() => api.transition(r.id, 'refuser'), 'Demande refusée.')}>Refuser</button>
            </Row>
          ))}
        </div>

        {/* 2. Devis en attente */}
        <div className="bk" data-testid="bloc-devis">
          <div className="bh"><h2>Devis en attente de réponse</h2><span className="n">{b.devis_attente.length}</span></div>
          {b.devis_attente.length === 0 ? <Empty t="Aucun devis en attente." /> : b.devis_attente.map((r) => (
            <Row key={r.id} r={r} onOpen={open}>
              <span className="bg bg-a">En attente client</span>
              <button className="btn btn-s" data-testid={`open-${r.id}`} onClick={() => open(r.id)}>Ouvrir</button>
            </Row>
          ))}
        </div>

        {/* 3. À préparer cette semaine */}
        <div className="bk" data-testid="bloc-preparer">
          <div className="bh"><h2>À préparer cette semaine</h2><span className="n">{b.a_preparer.length}</span></div>
          {b.a_preparer.length === 0 ? <Empty t="Rien à préparer cette semaine." /> : b.a_preparer.map((r) => (
            <Row key={r.id} r={r} onOpen={open}>
              {r.acompte_encaisse
                ? <span className="bg bg-g">Acompte réglé</span>
                : <span className="lk" data-testid={`lk-${r.id}`}>🔒 Acompte {eur0(r.acompte)} non réglé</span>}
              <button className="btn btn-s" disabled={!r.verrous.preparation.autorise} data-testid={`prep-${r.id}`}
                title={r.verrous.preparation.raison || ''}
                onClick={() => act(() => api.transition(r.id, 'preparer'), 'Dossier passé en préparation.')}>Préparer</button>
              {!r.acompte_encaisse && (
                <button className="btn btn-s btn-g" data-testid={`enc-${r.id}`}
                  onClick={() => act(() => api.paiementManuel(r.id, 'acompte'), 'Acompte encaissé.')}>Encaisser</button>
              )}
            </Row>
          ))}
        </div>

        {/* 4. Livraisons et retours du jour */}
        <div className="bk" data-testid="bloc-tournee">
          <div className="bh"><h2>Aujourd'hui : livraisons et retours</h2></div>
          {(b.livraisons_retours.livraisons.length + b.livraisons_retours.retours.length) === 0
            ? <Empty t="Aucune livraison ni retour aujourd'hui." />
            : (<>
              {b.livraisons_retours.livraisons.map((r) => (
                <Row key={`l-${r.id}`} r={r} onOpen={open}>
                  <span className="bg bg-b">Livraison</span>
                  {r.client_telephone && <a className="btn btn-s" href={`tel:${r.client_telephone}`} data-testid={`tel-${r.id}`}>📞 {r.client_telephone}</a>}
                  <button className="btn btn-s" data-testid={`open-l-${r.id}`} onClick={() => open(r.id)}>Ouvrir</button>
                </Row>
              ))}
              {b.livraisons_retours.retours.map((r) => (
                <Row key={`r-${r.id}`} r={r} onOpen={open}>
                  <span className="bg bg-a">Retour {r.heure_reprise || ''}</span>
                  <button className="btn btn-s" data-testid={`open-r-${r.id}`} onClick={() => open(r.id)}>Ouvrir</button>
                </Row>
              ))}
            </>)}
        </div>

        {/* 5. Argent en attente */}
        <div className="bk" data-testid="bloc-argent">
          <div className="bh"><h2>Argent en attente</h2><span className="n">{b.argent.length}</span></div>
          {b.argent.length === 0 ? <Empty t="Tout est encaissé. 🎉" /> : b.argent.map((r) => (
            <div className="rw" key={r.id} data-testid={`argent-${r.id}`}>
              <div className="gw" style={{ cursor: 'pointer' }} onClick={() => open(r.id)}>
                <div className="t">{r.client_nom} <span className="mono" style={{ color: 'var(--t3)', fontWeight: 500 }}>· {r.numero}</span></div>
                <div className="m">Reste dû <b className="mono" style={{ color: 'var(--ru)' }}>{eur(r.reste_du)}</b> · {r.libelle}</div>
              </div>
              <div className="ac">
                <button className="btn btn-s btn-g" data-testid={`regle-${r.id}`}
                  onClick={() => act(() => api.paiementManuel(r.id, r.acompte_encaisse ? 'solde' : 'acompte'), 'Paiement enregistré.')}>Marquer réglé</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
